/* unplugin-vue-components disabled */import script from "./Topbar.vue?vue&type=script&setup=true&name=Topbar&lang=js"
export * from "./Topbar.vue?vue&type=script&setup=true&name=Topbar&lang=js"

import "./Topbar.vue?vue&type=style&index=0&id=36caaef2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36caaef2"]])

export default __exports__